import clsx from 'clsx'
import moment from 'moment-jalaali'
import React from 'react'
import { ArrowDown, CheckIcon, Close } from 'src/icons/icons'
import { UnpaidCreditListItem } from 'src/types'
import { useUnpaidCreditsStore } from '../../../hooks'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

export const UnpaidRow = ({ ...record }: UnpaidCreditListItem & {}) => {

    const { t } = useTranslation();

    const lng = useSelector((state) => (state as any).common.lng)

    const { dispatch, selectedItems } = useUnpaidCreditsStore()

    const { id, created_at, transaction: { item }, previous_debt, inc, dec, is_paid, paid_amount, paid_crews } = record


    const handleSelectItem = (item: UnpaidCreditListItem, state: boolean) => {
        if (state) {
            {
                dispatch({ selectedItems: [...selectedItems, { credit: item, crews: item?.transaction?.item?.crews.map(i => i.crew_id) ?? [] }] })
            }
        }
        else {

            dispatch({ selectedItems: selectedItems.filter(i => i.credit.id != item.id) })

        }

    }

    if (item?.crews && item?.crews?.length > 0) {

        const { visa: { fa_name: visaTitle }, full_price } = item


        const crewVisaDebt = full_price - 0

        return item.crews.map(crewItem => {

            const isCrowPaid = typeof paid_crews != 'string' ? false : (JSON.parse(paid_crews) as unknown as Array<string>).findIndex(i => crewItem.crew_id) != -1

            return (<tr key={id} className="bg-white border-b border-gray-400 odd:bg-gray-50 border-r-transparent hover:border-r-primary-300 border-r-4 hover:bg-gray-100" >

                <td className="px-6 py-4 text-center">
                    <label className={"text-gray-500 text-sm mt-1"} title={t('Select')}>
                        <input
                            checked={selectedItems.findIndex(i => i.credit.id == id && i.crews.findIndex(f => f == crewItem?.crew_id) != -1) != -1}
                            type='checkbox'
                            className={clsx('rounded', (!crewItem?.crew || isCrowPaid) && 'pointer-even ts-none opacity-20 cursor-not-allowed')}
                            onChange={({ target: { checked } }) => handleSelectItem(record, checked)}
                            disabled={!crewItem?.crew || isCrowPaid}

                        />
                    </label>
                </td>



                <td className="px-6 py-4 text-center">
                    <div className={"text-gray-500 text-sm mt-1"}>
                        {id}
                    </div>
                </td>


                {/* <td className=" py-4 text-start text-gray-500 text-sm font-medium">
    <div className={"mt-1 flex justify-center"}>
      {item?.visa.visa?.[`${lng}_name`]} 
      , previous_debt < 0 ? 'text-red' : 'text-green-200'
    </div>
</td>*/}
                <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={"mt-1 flex justify-center"} title={moment(item?.created_at).format("jYYYY-jMM-jDD hh:mm:ss ")}>
                        {item?.created_at ? moment(item?.created_at).format(lng === "en" ? "YYYY-MM-DD" : "jYYYY-jMM-jDD") : '-'}
                    </div>
                </td>
                <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={clsx("mt-1 flex justify-center")} dir='ltr'>
                        {visaTitle}
                    </div>
                </td>
                <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={clsx("mt-1 flex justify-center", ' ')}>

                        {!crewItem?.crew ? t('CrewIsEmpty') : `${crewItem?.crew?.name ?? '-'} ${crewItem?.crew?.last_name ?? '-'}`}

                        {/* <span className='text-green-200 bg-green-100 p-1.5 rounded-lg'>

                            <span className='flex flex-row gap-2 items-center'>
                                <ArrowDown className=' rotate-180' />
                                {inc.toLocaleString()}
                            </span>
                        </span> */}
                        {/* {item.full_expired_at ? moment(item.full_expired_at).format(lng === "en" ? "YYYY-MM-DD" : "jYYYY-jMM-jDD") : '-'} */}
                    </div>
                </td>

                <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={"mt-1 flex justify-center "} >
                        <span>{full_price.toLocaleString()}</span>
                        {/* <span className=' text-red bg-rose-100 p-1.5 rounded-lg flex flex-row gap-2 items-center'>
                            <ArrowDown className='text-red ' />
                            <span>{dec.toLocaleString()}</span>
                        </span> */}
                        {/* {item?.full_price?.toLocaleString()} */}
                    </div>
                </td>


                <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={clsx("mt-1 flex justify-center font-bold", isCrowPaid ? 'text-green-200' : 'text-red')} >
                        <span>{(full_price - (isCrowPaid ? full_price : 0)).toLocaleString()}</span>
                        {/* <span className=' text-red bg-rose-100 p-1.5 rounded-lg flex flex-row gap-2 items-center'>
                            <ArrowDown className='text-red ' />
                            <span>{dec.toLocaleString()}</span>
                        </span> */}
                    </div>
                </td>


                <td className=" py-4 text-start text-gray-500 text-sm font-medium">
                    <div className={clsx("mt-1 flex justify-center text-center font-bold gap-2 items-center", is_paid ? 'text-green-200' : 'text-red')} >
                        {/* {isCrowPaid ? <CheckIcon className='size-6 text-green-500' /> : <Close color='red' />} */}

                        {isCrowPaid
                            ? <div className='p-2 rounded-xl text-center text-green-200 bg-green-100 font-bold'>
                                {t('Settle')}
                            </div>

                            : <div className='p-2 rounded-xl text-center text-red bg-rose-200 font-bold'>
                                {t('Debtor')}
                            </div>}
                        {/* <span>{item.is_paid ? t('Yes') : t('No')}</span> */}
                        {/* {item?.automation_number?.toLocaleString() ?? '-'} */}
                    </div>
                </td>

                {/* <td className=" py-4 text-start text-primary-400 text-base font-medium w-1/5">
    <div className={"mt-1"}>
        <div>{item?.subject ?? '-'}</div>

    </div>
</td>

<td className=" py-4 text-right">
    <div className={"flex justify-center cursor-pointer"}>

        {
            user?.role_key === "super_admin" &&
            <div onClick={() => navigate(`/visa-orders/forms/${item?.visa?.id}`)}>
            {!(item?.visa?.status === 0 || item?.visa?.status === 1) ? <FormIconPure /> : <FormIcon />}
            </div>
        } 

    </div>
</td>*/}
            </tr>)



        })
    }


    return <tr className=' rounded-xl  py-8  h-16   gap-2 mx-4  overflow-hidden text-center text-sm text-gray-500 odd:bg-gray-50'>
        <td colSpan={9} >
            {t('In')}  {t('visa')} {t('Record')} ID = {id} {t('CrewIsEmpty')}
        </td>
    </tr>

}
